import Utf8 from 'crypto-js/enc-utf8';
import Base64 from 'crypto-js/enc-base64';

export function encodeJSON(obj) {
    const wordArray = Utf8.parse(JSON.stringify(obj || {}));
    return Base64.stringify(wordArray);
}
export function decodeJSON(encodedJSON) {
    const selected = Base64.parse(encodedJSON).toString(Utf8) || '';
    return JSON.parse(selected);
}
